export default IconArrowMergeAltRight => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-merge-alt-right" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M16 7l-4 -4l-4 4" />
  <path d="M6 21v.01" />
  <path d="M6 18.01v.01" />
  <path d="M7 15.02v.01" />
  <path d="M10 13.03v.01" />
  <path d="M12 3v5.394a6.737 6.737 0 0 0 3 5.606a6.737 6.737 0 0 1 3 5.606v1.394" />
</svg>`;